/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_EVENT_TEMPLATE_ADMIN_SCOPES,
  GET_EVENT_TEMPLATE_ADMIN_SCOPES_SUCCESS,
  GET_EVENT_TEMPLATE_ADMIN_SCOPES_ERROR,
  GET_EVENT_TEMPLATE_ADMIN_LIST,
  GET_EVENT_TEMPLATE_ADMIN_LIST_SUCCESS,
  GET_EVENT_TEMPLATE_ADMIN_LIST_ERROR,
  UPSERT_EVENT_TEMPLATE_ADMIN,
  UPSERT_EVENT_TEMPLATE_ADMIN_SUCCESS,
  UPSERT_EVENT_TEMPLATE_ADMIN_ERROR,
  SET_EVENT_TEMPLATE_ADMIN_SCOPE,
  CLEAR_EVENT_TEMPLATE_ADMIN,
} from 'src/actions/eventTemplateAdminActions';

// CON-1487 Phase G — Event Template Defaults Admin slice.
//
// Separate from the user-scoped eventTemplates slice so that the admin
// flow has zero blast radius on existing user flows.

const initialState = {
  scopesLoading: false,
  scopes: [],
  listLoading: false,
  saving: false,
  companyKey: null,
  companyId: null,
  results: [],
};

const eventTemplateAdminReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_EVENT_TEMPLATE_ADMIN_SCOPES: {
      return produce(state, (draft) => {
        draft.scopesLoading = true;
      });
    }

    case GET_EVENT_TEMPLATE_ADMIN_SCOPES_SUCCESS: {
      return produce(state, (draft) => {
        draft.scopesLoading = false;
        draft.scopes = Array.isArray(payload?.scopes) ? payload.scopes : [];
      });
    }

    case GET_EVENT_TEMPLATE_ADMIN_SCOPES_ERROR: {
      return produce(state, (draft) => {
        draft.scopesLoading = false;
      });
    }

    case GET_EVENT_TEMPLATE_ADMIN_LIST: {
      return produce(state, (draft) => {
        draft.listLoading = true;
        draft.companyKey = payload?.companyKey ?? null;
        draft.companyId = payload?.companyId ?? null;
      });
    }

    case GET_EVENT_TEMPLATE_ADMIN_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.listLoading = false;
        draft.companyKey = payload?.companyKey ?? null;
        draft.companyId = payload?.companyId ?? null;
        draft.results = Array.isArray(payload?.results) ? payload.results : [];
      });
    }

    case GET_EVENT_TEMPLATE_ADMIN_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.listLoading = false;
      });
    }

    case UPSERT_EVENT_TEMPLATE_ADMIN: {
      return produce(state, (draft) => {
        draft.saving = true;
      });
    }

    case UPSERT_EVENT_TEMPLATE_ADMIN_SUCCESS: {
      return produce(state, (draft) => {
        draft.saving = false;
        const row = payload?.row;
        if (row?.id) {
          const idx = draft.results.findIndex((r) => r.id === row.id);
          if (idx !== -1) {
            draft.results[idx] = row;
          } else {
            draft.results.push(row);
          }
        }
      });
    }

    case UPSERT_EVENT_TEMPLATE_ADMIN_ERROR: {
      return produce(state, (draft) => {
        draft.saving = false;
      });
    }

    case SET_EVENT_TEMPLATE_ADMIN_SCOPE: {
      return produce(state, (draft) => {
        draft.companyKey = payload?.companyKey ?? null;
        draft.companyId = payload?.companyId ?? null;
      });
    }

    case CLEAR_EVENT_TEMPLATE_ADMIN: {
      return produce(state, () => initialState);
    }

    default:
      return state;
  }
};

export default eventTemplateAdminReducer;
